export default class RouteKey {
    static KEY_GST_PAYMENT_SIMPLIFIED = "/gst-payment-simplified";
}